import { getNumbersFromStr } from '@alfa-bank/site-form-helpers/text/get-numbers-from-str';

import type { IApiErrorResponse } from '../../../../helpers/api/models';
import { handleError, handleNoAuthResultResponse } from '../../helpers';
import { verifyPhoneCode } from '../../../../helpers/api';
import type { TAction } from '../../models';
import { retryAuthenticationViews, retryAuthenticationStatuses } from '../../config';

export const requestVerifyPhoneCode: TAction = async ({ form, values }) => {
    const { change, getState } = form;

    try {
        const { isRetryRequest, phone, prodType, signCode } = values;

        const {
            data: { availableSignMethods, documentsWasSigned },
        } = await verifyPhoneCode({
            phone: getNumbersFromStr(phone),
            signCode,
            prodType,
        });

        if (!documentsWasSigned) {
            handleNoAuthResultResponse({ availableSignMethods, change });

            if (isRetryRequest) {
                change('isRetryRequest', false);
            }

            return change('authenticationStep', 'checkConfirmationCode');
        }

        change('isAuthorized', 'true');
    } catch (error: unknown) {
        handleError(
            error as IApiErrorResponse,
            change,
            getState,
            retryAuthenticationViews,
            retryAuthenticationStatuses
        );
    }
};
